import script from "./ExtrasCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExtrasCard.vue?vue&type=script&setup=true&lang=ts"

import "./ExtrasCard.vue?vue&type=style&index=0&id=d0f71be4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0f71be4"]])

export default __exports__